/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_BehaviorInputs */



/**
* | output |
* | --- |
* | "Speaker Assignment Behavior" |
*
* @param {Options_Editor_Speaker_Assignment_BehaviorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_behavior = /** @type {((inputs?: Options_Editor_Speaker_Assignment_BehaviorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_BehaviorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comportement d'attribution des locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecherzuweisungsverhalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comportamento durante l'assegnazione dell'oratore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поведение при распределении докладчиков")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comportamiento de asignación de oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("说话人分配行为")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカー割り当ての動作")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता असाइनमेंट व्यवहार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comportamento de atribuição de locutor")
	return /** @type {LocalizedString} */ ("Speaker Assignment Behavior")
});